import ApplicationAdapter from './application';

export default class Term extends ApplicationAdapter {
  namespace = 'dates/v4';
  modelNamePlural = 'terms';
}
